// CallToAction.js

import React from 'react';
import './CallToAction.css'; // Import the CSS for the component
import { useNavigate } from 'react-router-dom';

const CallToAction = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/demo'); // Redirect to the demo page
    };

    return (
        <div className="call-to-action-container">
            <h2 className="call-to-action-heading">Experience the Future</h2>
            <div className="call-to-action-content">
                <p className="call-to-action-subheading">
                    Join the next generation of automation with our platform.<br /> Book a live demo now!
                </p>
            </div>
            <button className="call-to-action-button" onClick={handleClick}>
                Get Demo →
            </button>
        </div>
    );
};

export default CallToAction;
